import { render, staticRenderFns } from "./CashAccountMovementsList.vue?vue&type=template&id=670c858f&scoped=true"
import script from "./CashAccountMovementsList.vue?vue&type=script&lang=js"
export * from "./CashAccountMovementsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670c858f",
  null
  
)

export default component.exports